














import {Component, Vue} from 'vue-property-decorator';
import UserTable from '@/oauth/UserTable.vue';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import router from '@/router';

@Component({
  components: {UserTable},
})
export default class AuthorityVue extends Vue {
  private su = SecurityUtils;

  private mounted() {
    if (this.su.getLoginUser().id == undefined) {
      this.su.goToLogin();
      return;
    }
    if (!this.su.getLoginUser().hasRole('admin')) {
      router.push({name: '404'});
      return;
    }

  }
}
